import { FC, ReactNode, useMemo } from "react"
import { Fragment } from "react/jsx-runtime"
import AdminPagination from "./AdminPagination";
import { UseAppTableProps } from "hooks/useAppTable";
import AppEmpty from "./AppEmpty";


interface AppTableColumnProps<T> {
    hidden?: boolean;
    key: keyof T;
    label: ReactNode;
    textAlign?: "left" | "center" | "right";
    textAlignHead?: "left" | "center" | "right";
    textAlignBody?: "left" | "center" | "right";
    render?: (row: T) => ReactNode;
}
interface AppTableProps<T> {
    appTable: UseAppTableProps<T>;
    rowSelection?: boolean;
    columns: Array<AppTableColumnProps<T>>
}
const AppTable = <T extends object>({
    appTable,
    rowSelection = true,
    ...props
}: AppTableProps<T>) => {
    const columns = props.columns.filter(col => !col.hidden);
    const colSpan = useMemo(() => {
        return columns.length + 1 + (rowSelection ? 1 : 0);
    }, [columns.length, rowSelection])

    return <Fragment>
        <div className="bg-white shadow rounded">
            <table className="min-w-full table-auto rounded">
                <thead className="text-left text-white">
                    <tr>
                        {rowSelection && <th className="bg-blue-800 px-4 py-3 w-12 rounded-tl">
                            <input
                                type="checkbox"
                                className="accent-blue-600"
                                onClick={() => appTable.handleSelectAll()}
                                checked={appTable.isSelectedAll}
                            />
                        </th>}
                        <th className={`bg-blue-800 px-4 py-3 w-12 ${!rowSelection ? "rounded-tl" : ""}`}>#</th>
                        {columns.map((col, i) => <th key={i} className={`bg-blue-800 px-4 py-3 relative text-${col.textAlignHead || col.textAlign || "left"} ${i === columns.length - 1 ? "rounded-tr" : ""}`}>{col.label}</th>)}
                    </tr>
                </thead>
                <tbody className="text-gray-700">
                    {appTable.dataSource.map((item, i) => {
                        let stt: number = i + 1;
                        if (appTable.pagination) {
                            stt = appTable.pagination.pageSize * (appTable.pagination.page - 1) + i + 1
                        }
                        return <tr className="border-t">
                            {rowSelection && <td className="px-4 py-3">
                                <input
                                    type="checkbox"
                                    className="rowCheckbox accent-blue-600"
                                    onClick={() => appTable.handleSelect(item)}
                                    checked={appTable.selecteds.findIndex(s => s[appTable.rowKey] === item[appTable.rowKey]) >= 0}
                                />
                            </td>}
                            <td className="px-4 py-3">{stt}</td>
                            {columns.map((col, j) => {
                                const rowKey = col.key as keyof T;
                                const _item = item as any;
                                const value = (col.render && col.render(item)) || _item[rowKey];
                                return <td key={`${i}-${j}`} className={`px-4 py-3 text-${col.textAlignBody || col.textAlign || "left"}`} >{value}</td>
                            })}
                        </tr>
                    })}
                    {appTable.dataSource.length === 0 && <tr className="border-t">
                        <td className="px-4 py-3 text-center" colSpan={colSpan}>
                            {/* Không có dữ liệu */}
                            <AppEmpty />
                        </td>
                    </tr>}
                </tbody>
            </table>
        </div>
        <AdminPagination page={appTable.pagination?.page} pageSize={appTable.pagination?.pageSize} total={appTable.pagination?.total} />
    </Fragment>
}

export default AppTable;